<template>
  <div class="hot-form">
    <div class="title">决赛数据录入</div>
    <div class="person-list">
      <div class="person-card" v-for="person in personList" :key="person.id">
        <div class="person-header">
          <img class="person-avatar" :src="person.img" :onerror="`this.onerror=null;this.src='${touxiang}';`">
          <span class="person-name">{{ person.nickname }}</span>
        </div>
        <div class="score-list">
          <div class="score-item">
            <label>总分：</label>
            <input type="number" v-model.number="form[person.id].zf" />
          </div>
          <div class="score-item">
            <label>榜一百：</label>
            <input type="number" v-model.number="form[person.id].byb" />
          </div>
          <div class="score-item">
            <label>助力人数：</label>
            <input type="number" v-model.number="form[person.id].zlrs" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-item submit-wrap">
      <button :disabled="loading" @click="saveData">提交</button>
    </div>
    <loading :visible="loading" :message="statusMessage"></loading>
  </div>
</template>

<script>
import axios from '../axios-instance'
import userList from './data-0622.js'
import loading from '../page0518/loading'

const PERSON_IDS = [4, 29]
const EMPTY_ITEM = { zf: 0, byb: 0, zlrs: 0 }

export default {
  components: {
    loading
  },
  data () {
    return {
      loading: false,
      statusMessage: '处理中...',
      dataMap: {},
      form: this.initForm(),
      touxiang: require('../../assets/touxiang.png')
    }
  },
  computed: {
    personList () {
      return PERSON_IDS.map(id => userList.find(item => item.id === id)).filter(Boolean)
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    initForm () {
      const form = {}
      PERSON_IDS.forEach(id => {
        form[id] = { ...EMPTY_ITEM }
      })
      return form
    },
    parseResponseData (res) {
      if (res.data && res.data.code === 0 && res.data.data) {
        if (typeof res.data.data === 'string') {
          try {
            return JSON.parse(res.data.data)
          } catch (e) {
            console.error('响应数据解析失败：', e)
            return {}
          }
        }
        return res.data.data
      }
      return {}
    },
    getData () {
      this.loading = true
      return axios({
        url: 'https://yudao-api.yunlvltd.com/app-api/vote/kv/get/0627jsdata',
        method: 'get',
        timeout: 120000,
        headers: {
          'tenant-id': 1
        }
      }).then(res => {
        this.dataMap = this.parseResponseData(res) || {}
        PERSON_IDS.forEach(id => {
          const item = this.dataMap[id] || {}
          this.$set(this.form, id, {
            zf: item.zf || 0,
            byb: item.byb || 0,
            zlrs: item.zlrs || 0
          })
        })
      }).catch(err => {
        console.error(err)
        alert('数据加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    saveData () {
      if (this.loading) return false
      PERSON_IDS.forEach(id => {
        this.$set(this.dataMap, id, {
          zf: Number(this.form[id].zf) || 0,
          byb: Number(this.form[id].byb) || 0,
          zlrs: Number(this.form[id].zlrs) || 0
        })
      })
      this.loading = true
      axios({
        url: 'https://yudao-api.yunlvltd.com/app-api/vote/kv/set/0627jsdata',
        method: 'post',
        data: {
          value: JSON.stringify(this.dataMap)
        },
        timeout: 120000,
        headers: {
          'tenant-id': 1
        }
      }).then(res => {
        if (res.data && res.data.code === 0) {
          alert('提交成功')
        } else {
          alert('提交失败')
        }
      }).catch(err => {
        console.error(err)
        alert('提交失败')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scope>
.hot-form {
  width: 500px;
  margin: 20px auto;
}
.title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin: 20px 0;
  font-size: 24px;
}
.person-list {
  margin-bottom: 20px;
}
.person-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fafafa;
}
.person-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.person-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 12px;
}
.person-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.score-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.score-item {
  display: flex;
  align-items: center;
}
.score-item label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
}
.score-item input {
  flex: 1;
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.form-item {
  margin-bottom: 25px;
}
.submit-wrap {
  text-align: center;
}
button {
  background-color: #5ca1d8;
  color: #fff;
  border: none;
  padding: 8px 32px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 4px;
}
button:hover {
  background-color: #4b8cc4;
}
button:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/page260622/page-modify-data-js.vue